var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { useRecoilState, useRecoilValue } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
import { cmmType } from "../../../recoil/menuState";
import { userInfoLoginState } from "../../../recoil/userState";
import dayjs from "dayjs";
import EhpPagination from "../../common/pagination/EhpPagination";
import CmmConfirmPop from "../../common/popup/CmmConfirmPop";
export default function CommunityManagementReport(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [cmmSelType, setCmmSelType] = useRecoilState(cmmType);
    const [reportList, setReportList] = useState([{}]);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    const [searchWord, setWord] = useState("");
    const [searchType, setType] = useState("");
    const [selTypeNm, setSelTypeNm] = useState("전체");
    const [sortData, setSortData] = useState({
        sortField: "rownumber",
        sort: "asc",
    });
    const [selReport, setReport] = useState({});
    // props
    const { handleOpenPop } = props;
    useEffect(() => {
        handleOpenPop("pop-clear", _jsx(PauseAccountPop, { selReport: selReport, setUpdate: setUpdate }));
        handleOpenPop("pop-stopclear", _jsx(StopPauseAccountPop, { selReport: selReport, setUpdate: setUpdate }));
    }, [selReport]);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let page = `page=${pageInfo.number}&size=${pageInfo.size}&sort=${sortData.sortField},${sortData.sort}`;
    const [search, setSearch] = useState("");
    const [update, setUpdate] = useState(0);
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/communities/admin?${page}${search}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: page + search + update,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setReportList(data.body);
                setPageInfo(data.data.page);
                if (cmmSelType.nickName.length > 0) {
                    setWord(cmmSelType.nickName);
                    searchNickName();
                }
            }
        }
    }, [data]);
    useEffect(() => { }, [reportList]);
    function selectTr(e, index) {
        let target = e.currentTarget;
        let isBanned = reportList[index].isBanned;
        if (target.classList.contains("selected")) {
            target.classList.remove("selected");
            if (!isBanned)
                target.childNodes[7].childNodes[0].childNodes[0].innerText = "공개";
        }
        else {
            let trs = document.querySelector("#listBody").children;
            Array.prototype.forEach.call(trs, (element) => element.classList.remove("selected"));
            target.classList.add("selected");
            if (!isBanned)
                target.childNodes[7].childNodes[0].childNodes[0].innerText = "변경";
        }
    }
    function onChangeWord(e) {
        setWord(e.target.value);
    }
    function resetWord() {
        setWord("");
        setCmmSelType(Object.assign(Object.assign({}, cmmSelType), { nickName: "" }));
    }
    function searchNickName() {
        let option = `&nickName=${searchWord}`;
        if (searchType != "")
            option = option + `&type=${searchType}`;
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        setSearch(option);
    }
    function handleEnterKey(e) {
        if (e.key === "Enter") {
            searchNickName();
        }
    }
    function mouseOverBanned(e) {
        let target = e.currentTarget;
        let tr = target.closest("tr");
        if (!tr.classList.contains("selected")) {
            let span = target.childNodes;
            span[0].innerText = "변경";
        }
    }
    function mouseOutBanned(e) {
        let target = e.currentTarget;
        let tr = target.closest("tr");
        if (!tr.classList.contains("selected")) {
            let span = target.childNodes;
            span[0].innerText = "공개";
        }
    }
    function changeBannedState(e, item) {
        setReport(item);
        CUTIL.jsopen_Popup(e);
    }
    function onClickSelect(e) {
        let select = e.currentTarget;
        if (select.classList.contains("active")) {
            select.classList.remove("active");
        }
        else {
            select.classList.add("active");
        }
    }
    function onSelectBox(e) {
        let selType = e.currentTarget.dataset.value;
        let li = e.currentTarget;
        let lis = li.parentNode.childNodes;
        lis.forEach((item, index) => (item.className = "option"));
        li.className = "option active";
        setSelTypeNm(e.currentTarget.innerText);
        setType(selType);
        let option = `&type=${selType}`;
        if (searchWord != "")
            option = option + `&nickName=${searchWord}`;
        setSearch(option);
    }
    function onClickSort(e) {
        var actTag = e.target.tagName == "TH" ? e.target : e.currentTarget;
        var selSortField = actTag.getAttribute("data-value");
        var selSort = sortData.sort === "asc" ? "DESC" : "asc";
        if (selSortField !== sortData.sortField) {
            // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: 0 }));
        setSortData({
            sortField: selSortField,
            sort: selSort,
        });
    }
    function openPage(id) {
        if (!CUTIL.isnull(id)) {
            let url = window.location.origin + `/community?communityId=${id}`;
            window.open(url, "_blank");
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: "\uC2E0\uACE0 \uAC8C\uC2DC\uAE00/\uB313\uAE00 \uAD00\uB9AC" })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uC720\uD615" }) })), _jsxs("div", Object.assign({ className: "select w158", onClick: (e) => onClickSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: selTypeNm })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e), "data-value": "" }, { children: "\uC804\uCCB4" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e), "data-value": "community" }, { children: "\uAC8C\uC2DC\uAE00" })), _jsx("li", Object.assign({ className: "option", onClick: (e) => onSelectBox(e), "data-value": "reply" }, { children: "\uB313\uAE00" }))] })] }))] })) })) })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("div", Object.assign({ className: "searcharea" }, { children: _jsxs("div", Object.assign({ className: "searchinput" }, { children: [_jsx("span", Object.assign({ className: "mr-24" }, { children: _jsx("strong", { children: "\uB2C9\uB124\uC784" }) })), _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: searchWord, onChange: onChangeWord, onKeyDown: handleEnterKey }), searchWord != "" ? (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: resetWord }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) }))) : ("")] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: searchNickName }, { children: _jsx("span", { children: "\uAC80\uC0C9" }) }))] })) })) }))] })), _jsx("div", Object.assign({ className: "tbl-list userlist tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uB4F1\uB85D \uC21C,\uC720\uD615,\uC0C1\uC138\uC815\uBCF4,\uC774\uB984,\uC791\uC131\uC77C\uC790,\uC2E0\uACE0\uC218,\uC2E0\uACE0\uC0AC\uC720,\uAC8C\uC2DC\uC0C1\uD0DC \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2E0\uACE0 \uAC8C\uC2DC\uAE00/\uB313\uAE00 \uAD00\uB9AC \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC2E0\uACE0 \uAC8C\uC2DC\uAE00/\uB313\uAE00 \uAD00\uB9AC \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "25%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "7%" } }), _jsx("col", { style: { width: "36%" } }), _jsx("col", { style: { width: "108px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "rownumber" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "rownumber" }, { children: _jsx("span", { children: "\uB4F1\uB85D \uC21C" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC720\uD615" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC0C1\uC138\uC815\uBCF4" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB2C9\uB124\uC784" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC791\uC131 \uC77C\uC790" })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "claimCount" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "claimCount" }, { children: _jsx("span", { children: "\uC2E0\uACE0 \uC218" }) })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC2E0\uACE0 \uC0AC\uC720" })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "isBanned" ? (sortData.sort === "asc" ? "asc" : "desc") : "asc"}`, onClick: (e) => onClickSort(e), "data-value": "isBanned" }, { children: _jsx("span", { children: "\uAC8C\uC2DC\uC0C1\uD0DC" }) }))] }) }), _jsx("tbody", Object.assign({ id: "listBody" }, { children: reportList &&
                                                reportList.map((item, index) => (_jsxs("tr", Object.assign({ onClick: (e) => selectTr(e, index) }, { children: [_jsx("td", { children: item.rowNumber }), _jsx("td", { children: item.type }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis w90p", onClick: (e) => openPage(item.communityId) }, { children: item.detail })) }), _jsx("td", { children: item.nickName }), _jsx("td", { children: dayjs(item.updatedTime).format("YYYY-MM-DD") }), _jsx("td", { children: item.claimCount }), _jsx("td", { children: _jsx("p", Object.assign({ className: "flex" }, { children: item.claimReasons &&
                                                                    item.claimReasons.map((cItem, cIndex) => (_jsx("span", { children: cItem }, `reasons_${index}_${cIndex}`))) })) }), _jsx("td", { children: item.isBanned ? (_jsxs("button", Object.assign({ type: "button", "data-pop": "pop-stopclear", className: "btn-small-round red", onClick: (e) => changeBannedState(e, item) }, { children: [_jsx("span", { children: "\uBE44\uACF5\uAC1C" }), _jsx("span", { children: "\uD574\uC81C" })] }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no", "data-pop": "pop-clear", onMouseOver: mouseOverBanned, onMouseOut: mouseOutBanned, onClick: (e) => changeBannedState(e, item) }, { children: _jsx("span", { children: "\uACF5\uAC1C" }) }))) })] }), `report_${index}`))) }))] })) })), _jsx(EhpPagination, { componentName: "CONSULT", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })), _jsx(CmmConfirmPop, {})] }));
}
function PauseAccountPop(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    let selReport = props.selReport;
    const [contents, setContents] = useState("");
    const [errMsg, setErrMsg] = useState("");
    function onChangeContents(e) {
        setErrMsg("");
        let content = e.target.value;
        setContents(content);
    }
    let data = null;
    function onClickPause() {
        return __awaiter(this, void 0, void 0, function* () {
            let param = {};
            if (selReport.replyId == null) {
                param.communityId = selReport.communityId;
            }
            else {
                param.replyId = selReport.replyId;
            }
            param.status = 1;
            if (CUTIL.isnull(contents)) {
                setErrMsg("사유를 적어주세요.");
                return;
            }
            else if (contents.length > 20) {
                setErrMsg("사유는 20자를 넘을 수 없습니다.");
                return;
            }
            param.blindReason = contents;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/community/status`,
                appQuery: param,
                userToken: userInfo.loginInfo.token,
            });
            const ERR_URL = HTTPUTIL.resultCheck(true, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "게시글/댓글 관리", type: CONST.TYPE_NONE, divTag: `해당 ${selReport.type}이 블라인드 되었습니다.`, callBack: () => {
                            closePop();
                            props.setUpdate(Math.floor(Math.random() * 8999999) + 1000000);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function closePop() {
        CUTIL.jsclose_Popup("pop-clear");
        setContents("");
        setErrMsg("");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-clear", className: "popup-layer js-layer hidden popup-type1 w480" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uAC8C\uC2DC\uAE00/\uB313\uAE00 \uBE14\uB77C\uC778\uB4DC" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uBE14\uB77C\uC778\uB4DC \uC0AC\uC720" })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h146", onChange: onChangeContents, value: contents }), _jsxs("p", Object.assign({ className: "txtnum" }, { children: [contents.length, " / 20"] })), errMsg && (_jsx("p", Object.assign({ id: "errortxt", style: { color: "red" } }, { children: errMsg })))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: onClickPause }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
function StopPauseAccountPop(props) {
    // 화면 이동
    const navigate = useNavigate();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    let selReport = props.selReport;
    let data = null;
    function onClickPause() {
        return __awaiter(this, void 0, void 0, function* () {
            let param = {};
            if (selReport.replyId == null)
                param.communityId = selReport.communityId;
            if (selReport.replyId != null && selReport.communityId != null)
                param.replyId = selReport.replyId;
            param.status = 2;
            closePop();
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/community/status`,
                appQuery: param,
                userToken: userInfo.loginInfo.token,
            });
            const ERR_URL = HTTPUTIL.resultCheck(true, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { header: "신고 게시글/댓글 관리", type: CONST.TYPE_NONE, divTag: `해당 ${selReport.type}의 블라인드가 해제되었습니다.`, callBack: (e) => {
                            props.setUpdate(Math.floor(Math.random() * 8999999) + 1000000);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    props.setUpdate(Math.floor(Math.random() * 8999999) + 1000000);
                }
                else {
                    // closePop();
                    setAlert(Object.assign(Object.assign({}, alert), { header: "신고 게시글/댓글 관리", type: CONST.TYPE_NONE, divTag: "오류가 발생하였습니다. 관리자에게 문의해주세요.", callBack: (e) => { } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function closePop() {
        CUTIL.jsclose_Popup("pop-stopclear");
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-stopclear", className: "popup-layer js-layer hidden popup-basic" }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "\uC2E0\uACE0 \uAC8C\uC2DC\uAE00/\uB313\uAE00 \uAD00\uB9AC" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closePop }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: `[${selReport.banReason == null ? "기타" : selReport.banReason}] 사유로 블라인드된 ${selReport.type}입니다. 블라인드를 해제하시겠습니까?` }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: closePop }, { children: _jsx("span", { children: "\uCDE8\uC18C" }) })), _jsx("button", Object.assign({ type: "button", onClick: onClickPause }, { children: _jsx("span", { children: "\uD655\uC778" }) }))] }))] })) }));
}
